// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__HkKt7","choiceBoxes":"toolbarselects_choiceBoxes__3JXRE","simpleField":"toolbarselects_simpleField__2KhM3"};